var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_c('icon',{staticClass:"mb-1",attrs:{"name":"external-link-alt","scale":"0.8"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }